import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=708ff7bc&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=708ff7bc&lang=less&scoped=true&"
import style1 from "./setting.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ff7bc",
  null
  
)

export default component.exports